<template>
    <div class="relative text-gray-800 home">
        <header class="bg-left bg-cover lg:bg-center bg-siteLBlue bg-header">
            <div class="w-full max-w-screen-xl px-4 mx-auto">
                <div class="flex flex-wrap items-center py-4 -mx-4 overflow-hidden bg-white lg:bg-transparent lg:py-8">
                    <div class="w-full px-4 lg:w-3/5"></div>
                    <div class="w-full px-4 lg:w-2/5">
                        <div class="text-center">
                            <h1 class="text-2xl font-semibold uppercase text-siteDBlue lg:text-3xl">Linus Law Chambers</h1>
                            <h5 class="mb-4 font-semibold leading-none lg:mb-8 text-siteDBlue lg:text-lg">Advocates & Solicitors</h5>
                            <h4 class="text-lg lg:text-xl">Call us at <a href="tel:+6565364885" class="font-semibold">+65 6536 4885</a></h4>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full max-w-screen-xl px-4 mx-auto">
                <div class="flex flex-wrap items-center -mx-4 overflow-hidden">
                    <div class="w-full px-4 lg:w-3/5">
                        <div class="mt-12 mb-8 text-center lg:text-left lg:p-6 lg:bg-white lg:bg-opacity-80 lg:mb-24">
                            <h2 class="mb-2 text-4xl leading-tight text-siteDBlue lg:text-5xl">Civil & Commercial Litigation</h2>
                            <h3 class="textl-lg lg:text-xl">Veteran Lawyer with over 40 years' experience in litigation matters</h3>
                        </div>
                    </div>
                    <div class="w-full px-4 lg:w-2/5">
                        <div class="px-4 py-8 text-center text-white lg:py-16 lg:px-8 bg-siteDBlue enquiry-form">
                            <h4 class="mb-4 text-lg lg:mb-6 lg:text-xl"><span class="block font-semibold lg:inline">Free 1<sup>st</sup> Consultation,</span> Contact Us Today</h4>
                            <InquiryForm />
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <div class="py-12 text-center lg:py-16">
            <div class="w-full max-w-screen-lg px-4 mx-auto">
                <div class="flex flex-wrap items-center -mx-4 overflow-hidden">
                    <div class="w-full px-4">
                        <h3 class="mb-4 text-2xl leading-tight lg:text-3xl text-siteBlue">A Dedicated Law Firm with Proven Results</h3>
                        <p>Litigation matters are often tedious and complicated. We believe in protecting your legal rights by. providing effective solutions and maintaining high ethical and professional standards.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="py-12 lg:py-16 bg-siteLBlue">
            <div class="w-full max-w-screen-xl px-4 mx-auto">
                <div class="flex flex-wrap items-center -mx-4 overflow-hidden">
                    <div class="w-full px-4 lg:w-2/5">
                        <img class="mb-8 border-2 border-white rounded lg:mb-0" src="images/image-01.jpg">
                    </div>
                    <div class="w-full px-4 lg:w-3/5">
                        <h3 class="mb-6 text-2xl leading-tight lg:mb-8 lg:text-3xl text-siteBlue">About Linus Law Chambers</h3>
                        <p class="mb-4">Linus Law Chambers is founded by Linus Pereira. He graduated from the University of Singapore in 1979 and was admitted as an Advocate & Solicitor of the Supreme Court of Singapore in 1980. He started practicing as an Associate with Goh & Chia in 1980 and then as partner of L Pereira & Netto in 1983 before establishing Linus Law Chambers in 2013. Mr Pereira has more than 40 years of experience in various areas of the law, particularly, in Civil and Commercial Litigation, Divorce and Family Law, Accident and Personal Injury Claims, Probate and Administration of Estates, Criminal Law and Debt Recovery. Mr Pereira has handled cases in the State Courts, High Court and in the Court of Appeal. He is also a Notary Public and Commissioner for Oaths.</p>
                        <p>The firm believes in offering professional and personalised legal services to both individuals and corporate clients, and is dedicated to providing effective solutions and recommendations at affordable costs.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-no-repeat bg-btop lg:bg-left-top lg:bg-contain bg-slice-top">
            <div class="max-w-screen-xl px-4 mx-auto">
                <div class="py-12 bg-white lg:pt-24 lg:pb-16">
                    <div class="w-full max-w-screen-lg px-4 mx-auto">
                        <div class="flex flex-wrap -mx-4 overflow-hidden">
                            <div class="w-full px-4 lg:w-2/5 lg:order-2">
                                <img class="mb-8 border-2 border-white rounded lg:mb-0" src="images/image-02.jpg">
                            </div>
                            <div class="w-full px-4 lg:w-3/5 lg:order-1">
                                <h3 class="mb-6 text-2xl leading-tight lg:mb-8 lg:text-3xl text-siteBlue">Key Areas of Practice</h3>
                                <p class="mb-4">Linus Pereira has vast legal experience, and handled various type of cases over the years, with particular focus in following areas of practice:</p>
                                <ul class="pl-5 list-disc">
                                    <li class="mb-1">Civil & Commercial Litigation</li>
                                    <li class="mb-1">Corporate Law</li>
                                    <li class="mb-1">Commercial Agreements</li>
                                    <li class="mb-1">Work Injury Compensation Claims</li>
                                    <li class="mb-1">Landlord & Tenant</li>
                                    <li class="mb-1">Bankruptcy & Insolvency</li>
                                    <li class="mb-1">Debt Recovery</li>
                                    <li class="mb-1">Divorce & Family Law</li>
                                    <li class="mb-1">Criminal Law</li>
                                    <li class="mb-1">Banking & Finance</li>
                                    <li>Wills, Probate & Administration of Estates</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pb-12 lg:pb-24">
                    <div class="w-full max-w-screen-lg px-4 mx-auto">
                        <div class="flex flex-wrap -mx-4 overflow-hidden">
                            <div class="w-full px-4 lg:w-2/5">
                                <img class="mb-8 border-2 border-white rounded lg:mb-0" src="images/image-03.jpg">
                            </div>
                            <div class="w-full px-4 lg:w-3/5">
                                <h3 class="mb-6 text-2xl leading-tight lg:mb-8 lg:text-3xl text-siteBlue">Why Linus Law Chambers for Your Civil & Commercial Case?</h3>
                                <ul class="pl-5 list-disc">
                                    <li class="mb-1">More than 40 Years' Experience in Civil & Commercial Litigation</li>
                                    <li class="mb-1">High Success Rate in Achieving a Favourable Outcome</li>
                                    <li class="mb-1">Honest & Affordable Fees for Your Peace of Mind</li>
                                    <li>Passionate and Meticulous Legal Work</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-bottom bg-no-repeat bg-cover lg:pb-40 lg:bg-left-bottom lg:bg-contain bg-slice-bottom">
            <div class="max-w-screen-xl px-4 mx-auto">
                <div class="pb-12 text-center text-white lg:pb-16">
                    <div class="max-w-screen-lg px-4 mx-auto">
                        <div class="flex flex-wrap -mx-4 overflow-hidden">
                            <div class="w-full px-4">
                                <div class="px-4 py-8 lg:py-12 lg:px-8 bg-siteDBlue">
                                    <h3 class="mb-6 text-2xl leading-tight lg:mb-8 lg:text-3xl">Settle Your Litigation Matters with an Accurate Analysis of Your Case By An Experienced Lawyer Today</h3>
                                    <a href="tel:+6565364885" class="inline-block px-8 py-4 rounded lg:text-lg bg-sitePBlue text-siteDBlue">Call +65 6536 4885</a>
                                    <h5 class="lg:text-lg text-sitePBlue font-medium mt-2">Free 1<sup>st</sup> Consultation</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="py-12 lg:pt-16 lg:pb-24 bg-siteLBlue">
            <div class="w-full max-w-screen-xl px-4 mx-auto">
                <div class="flex flex-wrap -mx-4 overflow-hidden">
                    <div class="w-full px-4 lg:w-2/5">
                        <div class="px-4 py-8 text-center text-white lg:py-16 lg:px-8 bg-siteDBlue enquiry-form">
                            <h4 class="mb-4 text-lg lg:mb-6 lg:text-xl"><span class="font-semibold">Reach Out Today</span> for Quick Legal Advice</h4>
                            <InquiryForm />
                        </div>
                    </div>
                    <div class="w-full px-4 lg:w-3/5">
                        <iframe class="mb-8" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d997.2032760357196!2d103.84356092660889!3d1.2861745990619091!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da190ca4cad211%3A0x68dc85c8d82ecd8!2sLinus%20Law%20Chambers!5e0!3m2!1sen!2sph!4v1631030402557!5m2!1sen!2sph" width="100%" height="300" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
                        <h3 class="mb-6 text-2xl leading-tight lg:mb-8 lg:text-3xl"><span class="block font-semibold text-siteDBlue lg:inline">Linus Law Chambers</span></h3>
                        <p class="mb-4">
                            People's Park Centre<br>
                            101 Upper Cross Street #05-27<br>
                            Singapore 058357
                        </p>
                        <p class="mb-4">
                            Tel: <a href="tel:+6565364885">(65) 6536 4885</a><br>
                            Fax: (65) 6536 5013
                        </p>
                        <p>
                            Email: <a href="mailto:linus@linuslaw.com.sg">linus@linuslaw.com.sg</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <footer class="py-4 text-center text-white bg-siteDBlue lg:py-8">
            <div class="w-full max-w-screen-xl px-4 mx-auto">
            </div>
        </footer>
    </div>
</template>

<style>
    .bg-header {
        background-image: url(/images/bg-header-mobile.jpg);
    }
    .bg-slice-top {
        background-image: url(/images/bg-slice-top.png);
    }
    .bg-slice-bottom {
        background-image: url(/images/bg-slice-bottom.png);
    }
    @media (min-width: 1024px) {
        .bg-header {
            background-image: url(/images/bg-header.jpg);
        }
    }
</style>

<script>
    import { Carousel, Slide } from 'vue-carousel'
    import { CollapseTransition } from 'vue2-transitions'
    import InquiryForm from '@/components/InquiryForm.vue'

    export default {
        components: {
            CollapseTransition,
            Carousel,
            Slide,
            InquiryForm,
        },
        data() {
            return {
                index: 0,
            }
        }
    }
</script>